(() => {
    "use strict";
    var e,
        t = {
            6672: (e, t, n) => {
                function i() {
                    this.entries = [];
                }
                function o(e, t) {
                    return (
                        r(e),
                        (function (e) {
                            if (Array.isArray(e) && "object" == typeof e[0]) throw new Error(e + "is not a valid array of options.");
                        })(t),
                        e.variants.filter(function (e) {
                            return t.every(function (t, n) {
                                return e.options[n] === t;
                            });
                        })[0] || null
                    );
                }
                function r(e) {
                    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
                    if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.");
                }
                (i.prototype.add = function (e, t, n) {
                    this.entries.push({ element: e, event: t, fn: n }), e.addEventListener(t, n);
                }),
                    (i.prototype.removeAll = function () {
                        this.entries = this.entries.filter(function (e) {
                            return e.element.removeEventListener(e.event, e.fn), !1;
                        });
                    });
                function a(e, t, n) {
                    (this.element = e),
                        (this.product = (function (e) {
                            if ("object" != typeof e) throw new TypeError(e + " is not an object.");
                            if (void 0 === e.variants[0].options)
                                throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                            return e;
                        })(t)),
                        (n = n || {}),
                        (this._listeners = new i()),
                        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, n)),
                        (this.optionInputs = this._initInputs('[name^="options"]', n.onOptionChange)),
                        (this.quantityInputs = this._initInputs('[name="quantity"]', n.onQuantityChange)),
                        (this.propertyInputs = this._initInputs('[name^="properties"]', n.onPropertyChange));
                }
                (a.prototype.destroy = function () {
                    this._listeners.removeAll();
                }),
                    (a.prototype.options = function () {
                        return (
                            (e = this.optionInputs),
                            (t = function (e) {
                                return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
                            }),
                            e.reduce(function (e, n) {
                                return (n.checked || ("radio" !== n.type && "checkbox" !== n.type)) && e.push(t({ name: n.name, value: n.value })), e;
                            }, [])
                        );
                        var e, t;
                    }),
                    (a.prototype.variant = function () {
                        return (function (e, t) {
                            r(e);
                            var n = (function (e, t) {
                                r(e),
                                    (function (e) {
                                        if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
                                        if (0 === e.length) return [];
                                        if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
                                        if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.");
                                    })(t);
                                var n = [];
                                return (
                                    t.forEach(function (t) {
                                        for (var i = 0; i < e.options.length; i++)
                                            if (e.options[i].name.toLowerCase() === t.name.toLowerCase()) {
                                                n[i] = t.value;
                                                break;
                                            }
                                    }),
                                    n
                                );
                            })(e, t);
                            return o(e, n);
                        })(this.product, this.options());
                    }),
                    (a.prototype.properties = function () {
                        var e,
                            t,
                            n =
                                ((e = this.propertyInputs),
                                (t = function (e) {
                                    return /(?:^(properties\[))(.*?)(?:\])/.exec(e)[2];
                                }),
                                e.reduce(function (e, n) {
                                    return (n.checked || ("radio" !== n.type && "checkbox" !== n.type)) && (e[t(n.name)] = n.value), e;
                                }, {}));
                        return 0 === Object.entries(n).length ? null : n;
                    }),
                    (a.prototype.quantity = function () {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                    }),
                    (a.prototype._setIdInputValue = function (e) {
                        var t = this.element.querySelector('[name="id"]');
                        t || (((t = document.createElement("input")).type = "hidden"), (t.name = "id"), this.element.appendChild(t)), (t.value = e.toString());
                    }),
                    (a.prototype._onSubmit = function (e, t) {
                        (t.dataset = this._getProductFormEventData()), t.dataset.variant && this._setIdInputValue(t.dataset.variant.id), e.onFormSubmit && e.onFormSubmit(t);
                    }),
                    (a.prototype._onFormEvent = function (e) {
                        return void 0 === e
                            ? Function.prototype
                            : function (t) {
                                  (t.dataset = this._getProductFormEventData()), e(t);
                              }.bind(this);
                    }),
                    (a.prototype._initInputs = function (e, t) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
                            function (e) {
                                return this._listeners.add(e, "change", this._onFormEvent(t)), e;
                            }.bind(this)
                        );
                    }),
                    (a.prototype._getProductFormEventData = function () {
                        return { options: this.options(), variant: this.variant(), properties: this.properties(), quantity: this.quantity() };
                    });
                var c = n(1903),
                    s = n(3058),
                    l = n.n(s);
                n(3892);
                const d = document.currentScript.getAttribute("section-id"),
                    u = JSON.parse(document.querySelector(`[data-settings-id='${d}']`).innerHTML);
                (window.machinePDP.currentViewProduct = JSON.parse(l()("#pdp-product-json").html())), (window.machinePDP.currentSelectedVariant = ""), (window.machinePDP.variantExist = !0);
                let p,
                    m,
                    h,
                    v = !1,
                    y = !1,
                    f = !1,
                    w = 6,
                    b = !1;
                function g() {
                    let e = document.querySelector(".tab-view-bundle-content"),
                        t = document.querySelector("input[name='options[Bundle]']:checked").nextElementSibling.querySelector(".slider-view-bundle-content").innerHTML;
                    e.classList.remove("show-more-available", "is-expanded"), e.classList.add("remove-transitions"), (e.innerHTML = t);
                    let n = e.scrollHeight - e.clientHeight;
                    (e.children.length > w || n > 25) && e.classList.add("show-more-available"), e.classList.remove("remove-transitions");
                }
                function S() {
                   /* let e = document.querySelector(".pdp-atc"),
                        t = e.querySelector(".pdp-bundle-name"),
                        n = window.machinePDP.currentSelectedVariant,
                        //i = document.querySelector("input[name='options[Bundle]']:checked").value;
                    n && n.available ? (e.disabled = "") : (e.disabled = "disabled"), (t.innerHTML = i);*/
                }
                function q() {
                    let e = window.machinePDP.currentSelectedVariant;
                    if (!e) return;
                    const t = (function (e, t) {
                        return /variant=/.test(e) ? e.replace(/(variant=)[^&]+/, "$1" + t) : /\?/.test(e) ? e.concat("&variant=").concat(t) : e.concat("?variant=").concat(t);
                    })(window.location.href, e.id);
                    window.history.replaceState({ path: t }, "", t);
                }
                function E() {
                 //    let e, t;
                 //  if (document.querySelector(".machine-pdp-deal-variant") != null)
                 //  e = document.querySelector(".machine-pdp-deal-variant")
                 //  if (document.querySelector("input[name='options[Color]']:checked").value == null)
                 // return;
                 //    else
                 //  t = document.querySelector("input[name='options[Color]']:checked").value;
                        
                 //       if (!e || !t) {
                 //            console.error("Element with class 'machine-pdp-deal-variant' not found");
                 //            return;
                 //        }
                 //    e.querySelectorAll("input").forEach(function (e) {
                 //        let n = o(window.machinePDP.currentViewProduct, [t, e.value]),
                 //            i = e.nextElementSibling,
                 //            r = "",
                 //            a = i.querySelector(".slider-view-bundle-content"),
                 //            c = i.querySelector(".variant-bundle-price"),
                 //            s = i.querySelector(".variant-bundle-old-price");
                 //        if (
                 //            ((a.innerHTML = ""),
                 //            (c.innerHTML = ""),
                 //            (s.innderHTML = ""),
                 //            a.classList.add("remove-transitions"),
                 //            i.classList.remove("out-of-stock", "pushed-back", "not-exist"),
                 //            a.classList.remove("show-more-available", "is-expanded"),
                 //            !n)
                 //        )
                 //            return i.classList.add("not-exist", "pushed-back"), void (a.innerHTML = window.machinePDP.bundleDoesNotExistText);
                 //        n.available || i.classList.add("out-of-stock", "pushed-back"),
                 //            (c.innerHTML = formatMoney(n.price)),
                 //            n.compare_at_price > 0 ? (s.innerHTML = formatMoney(n.compare_at_price)) : (s.innerHTML = ""),
                 //            window.machinePDP.variantBlockSettings.forEach(function (e) {
                 //                e.settings.bundle_sku == n.sku && (r = e.settings.bundle_content);
                 //            }),
                 //            (a.innerHTML = r);
                 //        let l = a.scrollHeight - a.clientHeight;
                 //        (a.children.length > w || l > 25) && a.classList.add("show-more-available"), a.classList.remove("remove-transitions");
                 //    });
                }
                function L() {
                   /* let e = document.querySelector("input[name='options[Color]']:checked").value,
                        t = document.querySelector("input[name='options[Bundle]']:checked").value;
                    (window.machinePDP.currentSelectedVariant = o(window.machinePDP.currentViewProduct, [e, t])),
                        window.machinePDP.currentSelectedVariant
                            ? ((document.querySelector(".product-form-selector").value = window.machinePDP.currentSelectedVariant.id), (window.machinePDP.variantExist = !0))
                            : (window.machinePDP.variantExist = !1);*/
                }
                function P() {
                    let e = window.machinePDP.currentSelectedVariant;
                    e && document.querySelector("[data-sku='" + e.sku + "'")
                        ? (document.querySelector(".machine-pdp-images-container").classList.remove("gallery-not-exist"),
                          document.querySelectorAll(".single-item-image").forEach(function (t) {
                              t.dataset.sku == e.sku ? t.classList.add("d-flex") : t.classList.remove("d-flex");
                          }))
                        : document.querySelector(".machine-pdp-images-container").classList.add("gallery-not-exist");
                        //p.update();
                }
                if (
                    (window.innerWidth < 992 && ((y = !0), (f = !0), (w = 4)),
                    1 == document.querySelectorAll(".machine-pdp-deal-variant label").length && ((b = !0), document.querySelector(".machine-pdp-deal-variant").classList.add("single-bundle")),
                    document.querySelector(".machine-pdp-variant-tabs") &&
                        (document.querySelectorAll(".machine-pdp-variant-tabs label").length > 3 || window.innerWidth < 992
                            ? (document.querySelector(".machine-pdp-variant-tabs").classList.add("machine-pdp-variant-slider"), document.querySelector(".machine-pdp-variant-tabs").classList.remove("machine-pdp-variant-tabs"), (v = !1))
                            : (v = !0)),
                    document.addEventListener("DOMContentLoaded", function () {
                        document
                            .querySelector(".machine-pdp-options-container")
                            .querySelectorAll('input[type="radio"]')
                            .forEach(function (e) {
                                e.addEventListener("click", function (e) {
                                    L(), P(), S(), window.machinePDP.variantExist && q(), "options[Color]" == e.target.getAttribute("name") && E(), v && g();
                                });
                            }),
                            (function () {
                                let e = document.querySelector(".machine-pdp-color-variant"),
                                    t = document.querySelector(".machine-pdp-deal-variant");
                                e.querySelectorAll("input").forEach(function (b) {
                                    let n = b.value,
                                        i = [];
                                    if (t) {
                                        t.querySelectorAll("input").forEach(function (e) {
                                            let t = e.value,
                                                r = o(window.machinePDP.currentViewProduct, [n, t]);
                                            r && r.available && i.push(e);
                                        });
                                    }
                                    i.length || ((b.disabled = !0), b.closest(".variant-option").classList.add("crossed-out"));
                                })

                                });
                            }),
                            L(),
                            E(),
                            P(),
                            S(),
                            q(),
                            v && g(),
                            document.querySelectorAll(".slider-view-bundle-content").forEach(function (e) {
                                e.addEventListener("click", function (e) {
                                    this.classList.contains("show-more-available") && (k("", "show more/show less slider pdp"), this.classList.toggle("is-expanded")),
                                        e.defaultPrevented && (this.closest("label").previousElementSibling.click(), (this.closest("label").previousElementSibling.checked = !0));
                                });
                            }),
                            v &&
                                document.querySelector(".tab-view-bundle-content").addEventListener("click", function (e) {
                                    this.classList.contains("show-more-available") && (this.classList.toggle("is-expanded"), k("", "show more/show less tab pdp"));
                                }),
                            (function () {
                                let e = document.querySelector(".machine-pdp-images-container").clientWidth;
                                (document.querySelector(".pdp-machine-gallery").style.height = e + "px"),
                                    (document.querySelector(".pdp-images-gallery").style.height = e + "px"),
                                    document.querySelector(".machine-pdp-main-section model-viewer") && (document.querySelector(".machine-pdp-main-section model-viewer").style.height = e + "px"),
                                    (document.querySelector(".pdp-variant-not-exist").style.height = e + "px"),
                                    (document.querySelector(".pdp-gallery-selector").style.height = e + "px");
                                let t = document.querySelectorAll(".machine-pdp-gallery-opener"),
                                    n = document.querySelectorAll(".pdp-gallery-holder");
                                t.forEach(function (e) {
                                    let i = e.dataset.target;
                                    e.addEventListener("click", function () {
                                        t.forEach(function (t) {
                                            t.classList.remove("selected"), t === e && t.classList.add("selected");
                                        }),
                                            n.forEach(function (e) {
                                                e.classList.remove("d-flex"), e.dataset.window === i && e.classList.add("d-flex");
                                            });
                                    });
                                });
                            })(),
                            document.querySelector(".machine-pdp-main-section .anchor-holder") &&
                                (function () {
                                    let e = document.querySelector(".pdp-atc"),
                                        t = document.querySelector(".machine-pdp-main-section .anchor-holder");
                                    document.addEventListener(
                                        "scroll",
                                        function () {
                                            !(function (e) {
                                                const t = e.getBoundingClientRect();
                                                return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
                                            })(e)
                                                ? t.classList.remove("anchor-hidden")
                                                : t.classList.add("anchor-hidden");
                                        },
                                        { passive: !0 }
                                    ),
                                        y && t.classList.remove("anchor-hidden"),
                                        document.querySelector(".machine-pdp-main-section .anchor-holder button").addEventListener("click", function () {
                                            document.getElementById("pdp-machine-new").scrollIntoView({ behavior: "smooth" });
                                        });
                                })(),
                            (function () {
                                let e = y ? document.querySelector(".info-tabs-reviews-tab-wrapper") : document.querySelector("[data-info-tabs-source='reviews']"),
                                    t = y ? document.querySelector(".mobile-machine-information .pdp-block-review") : document.querySelector(".desktop-machine-information .pdp-block-review");
                                e &&
                                    t &&
                                    t.addEventListener("click", function (t) {
                                        e.classList.contains("active") || e.click(), e.scrollIntoView({ behavior: "smooth" }), k("", "machine pdp review score");
                                    });
                            })(),
                            (function () {
                                const e = document.getElementById("infoMetafieldsMobile"),
                                    t = l()("#machineTooltipsModal"),
                                    n = new c.Z("#machineTooltipsModal .swiper", { slidesPerView: "1", rewind: !0, navigation: { prevEl: "#tooltipModalPrev", nextEl: "#tooltipModalNext" } });
                                Array.from(e.children).forEach((e) => {
                                    e.addEventListener("click", () => {
                                        t.data("activeSwiper", e.dataset.metafieldIndex), t.modal("show");
                                    });
                                });
                                    t.on("shown.bs.modal", function () {
                                        n.slideTo(t.data("activeSwiper"), 0);
                                    });
                            })())
                    ,
                    !v && !b)
                 {
                    /*const e = new c.Z(".machine-pdp-options-container .machine-pdp-deal-variant", {
                        slidesPerView: "auto",
                        spaceBetween: 15,
                        rewind: !0,
                        allowTouchMove: f,
                        pagination: { el: ".machine-pdp-options-container .pdp-bundles-pagination", type: "bullets", clickable: !0 },
                        navigation: { nextEl: ".machine-pdp-options-container .pdp-bundle-next" },
                    });
                    e.on("slideChange", function () {
                        let e = this.slides[this.activeIndex];
                        e.previousElementSibling.click(),
                            (e.previousElementSibling.checked = !0),
                            this.isEnd ? this.el.classList.add("pdp-slider-end") : this.el.classList.remove("pdp-slider-end"),
                            k("clicked bundle pdp", document.querySelector("input[name='options[Bundle]']:checked").value);
                    });
                  let bundleInput = document.querySelector("input[name='options[Bundle]']");
                  let t = 0;
                  if (bundleInput && bundleInput.checked) {
                    t = bundleInput.dataset.valuePosition;
                  }
                  e.slideTo(t);*/
                }
                function k(e, t) {
                    preDataLayer.push({ event: "newEvent", newEventData: { type: "Click", elementType: t, elementId: e } });
                }
                israelShop
                    ? ((m = ".machine-pdp-main-section .pdp-gallery-prev"), (h = ".machine-pdp-main-section .pdp-gallery-next"))
                    : ((h = ".machine-pdp-main-section .pdp-gallery-prev"), (m = ".machine-pdp-main-section .pdp-gallery-next")),
                    (p = y
                        ? new c.Z(".machine-pdp-main-section .pdp-images-gallery", { direction: "horizontal", slidesPerView: 1, rewind: !0, navigation: { prevEl: h, nextEl: m } })
                        : new c.Z(".machine-pdp-main-section .pdp-images-gallery", {
                              direction: "vertical",
                              height: document.querySelector(".machine-pdp-images-container").clientWidth,
                              mousewheel: { forceToAxis: !0 },
                              rewind: !0,
                              pagination: {
                                  el: ".machine-pdp-main-section .pdp-gallery-pagination",
                                  type: "custom",
                                  renderCustom: function (e, t, n) {
                                      return (
                                          (i = u.pagination_text),
                                          (o = { current: t, total: n }),
                                          i && o
                                              ? i.replace(/_(.*?)_/gm, (e) => {
                                                    const t = e.replaceAll("_", "");
                                                    return void 0 === o[t] && console.error(`[settingsParam] undefined param - ${t} - accepted params - ${Object.keys(o)}`), o[t];
                                                })
                                              : console.error(`[settingsParam]Problem Reading - text: ${i}, data: ${JSON.stringify(o)}`)
                                      );
                                      var i, o;
                                  },
                              },
                              navigation: { nextEl: ".machine-pdp-main-section .pdp-button-next" },
                          }));
            },
        },
        n = {};
    function i(e) {
        var o = n[e];
        if (void 0 !== o) return o.exports;
        var r = (n[e] = { exports: {} });
        return t[e].call(r.exports, r, r.exports, i), r.exports;
    }
    (i.m = t),
        (e = []),
        (i.O = (t, n, o, r) => {
            if (!n) {
                var a = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    for (var [n, o, r] = e[d], c = !0, s = 0; s < n.length; s++) (!1 & r || a >= r) && Object.keys(i.O).every((e) => i.O[e](n[s])) ? n.splice(s--, 1) : ((c = !1), r < a && (a = r));
                    if (c) {
                        e.splice(d--, 1);
                        var l = o();
                        void 0 !== l && (t = l);
                    }
                }
                return t;
            }
            r = r || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > r; d--) e[d] = e[d - 1];
            e[d] = [n, o, r];
        }),
        (i.n = (e) => {
            var t = e && e.__esModule ? () => e.default : () => e;
            return i.d(t, { a: t }), t;
        }),
        (i.d = (e, t) => {
            for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
        }),
        (i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
        (() => {
            var e = { 5160: 0 };
            i.O.j = (t) => 0 === e[t];
            var t = (t, n) => {
                    var o,
                        r,
                        [a, c, s] = n,
                        l = 0;
                    if (a.some((t) => 0 !== e[t])) {
                        for (o in c) i.o(c, o) && (i.m[o] = c[o]);
                        if (s) var d = s(i);
                    }
                    for (t && t(n); l < a.length; l++) (r = a[l]), i.o(e, r) && e[r] && e[r][0](), (e[r] = 0);
                    return i.O(d);
                },
                n = (self.webpackChunk = self.webpackChunk || []);
            n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
        })();
    var o = i.O(void 0, [6967, 9607, 11, 8070], () => i(6672));
    o = i.O(o);
})();
